import { createSelector } from 'reselect';

import getSubscriptionsWithConditions from '~/src/features/full-buy/store/selectors/getSubscriptionsWithConditions';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TState } from '~/src/store';

const getStateForTariffInfoButton = createSelector(
    [
        getSubscriptionsWithConditions,
        selectCurrentTariff,
        (state: TState) => state.fullBuy._backgroundLoading,
    ],
    (subscriptions, tariff, loading) => ({
        subscriptions,
        tariff,
        loading,
    }),
);

export default getStateForTariffInfoButton;
